import { IndexCardStack } from './index-card-stack';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { GenericIndexCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/index-cards-3x5/generic-index-card-stack-background/generic-index-card-stack-background.component';
import { GenericIndexCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/index-cards-3x5/generic-index-card-stack-content/generic-index-card-stack-content.component';
import type { CardData } from '../../../../print-cards/card-data';

export class GenericIndexCardStack extends IndexCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> {
    return GenericIndexCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> {
    return GenericIndexCardStackContentComponent;
  }
}
